import { useState } from "react";
import { Link } from "react-router-dom";
import { actionOpenHref, canOpenAction } from "../lib/actionLinks";

const TONE = {
  "DECISION REQUIRED": "rose",
  "APPROVAL REQUIRED": "amber",
  WARNING: "amber",
  INFORMATION: "cyan",
};

function rowKey(item) {
  return `${item.queue || "row"}-${item.application}-${item.gate || item.kind || item.severity}-${item.route}`;
}

function Queue({ label, items, appId, guide }) {
  const [open, setOpen] = useState({});
  if (!items?.length) return null;
  return (
    <div className="attention-queue">
      <p className="kicker">{label}</p>
      <div className="attention-list">
        {items.map((item) => {
          const href = actionOpenHref(item, guide, appId);
          const key = rowKey(item);
          const expanded = Boolean(open[key]);
          const rowClass = `attention-row tone-${TONE[item.severity] || "slate"}`;
          const canOpen = canOpenAction(item, guide);
          const oneLiner = item.title || item.severity;
          return (
            <div key={key} className={`${rowClass}${canOpen ? "" : " attention-capped"}`} data-testid={`attention-${(item.application || "na").toLowerCase()}`}>
              <em>{item.severity}</em>
              <strong>{oneLiner}</strong>
              <span>Pending {item.pending_by || guide?.accountable_owner || "a named owner"}</span>
              {canOpen ? (
                <Link className="attention-open attention-open-inline" to={href}>Open</Link>
              ) : (
                <small className="attention-capped-note">Request review</small>
              )}
              <button
                type="button"
                className="attention-toggle"
                aria-expanded={expanded}
                aria-label={expanded ? "Collapse" : "Expand"}
                data-testid={`attention-toggle-${(item.application || "na").toLowerCase()}`}
                onClick={() => setOpen((prev) => ({ ...prev, [key]: !prev[key] }))}
              >
                {expanded ? "−" : "+"}
              </button>
              {expanded && (
                <div className="attention-detail">
                  <span>{item.detail}</span>
                  {item.hierarchy && <small>{item.hierarchy}</small>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function Attention({ items, approvals, actions, waiting, appId, guide }) {
  const queued = Boolean((approvals && approvals.length) || (actions && actions.length) || (waiting && waiting.length));
  const sections = queued
    ? [
        { label: "MY APPROVALS · L2", rows: approvals },
        { label: "MY ACTIONS · L2", rows: actions },
        { label: "WAITING", rows: waiting },
      ]
    : [{ label: "MY ATTENTION · L2", rows: items }];
  if (!sections.some((section) => section.rows?.length)) return null;
  return (
    <section className="attention-panel" data-testid="my-attention">
      <div className="panel-header">
        <div>
          <p className="kicker">FOCUS QUEUES · L2</p>
          <h2>What requires a human next</h2>
        </div>
      </div>
      {sections.map((section) => (
        <Queue
          key={section.label}
          label={section.label}
          items={section.rows}
          appId={appId}
          guide={guide}
        />
      ))}
    </section>
  );
}
